export const benefits = {
    mainTitle: "NUESTROS BENEFICIOS",
    mainSubTitle: "¿POR QUÉ ELEGIR HISOL?",
    items: [
        { title: "Mejore la fachada de su inmueble." },
        { title: "Equipo especializado en edificios y estructuras a gran altura y difícil acceso." },
        { title: "Aumento de plusvalía en su inmueble." },
        { title: "Protección de su inversión." },
        { title: "Proyectos a la medida." },
        { title: "Garantía de entrega en tiempo y forma." },
        { title: "Certificaciones internacionales de seguridad y de trabajos en gran altura y difícil acceso." },
        { title: "Flexibilidad económica." },
        { title: "Seguimiento documentado e informativo." },
        { title: "Cobertura integral en edificios y estructuras." }
    ]
};

export const benefitsEn = {
    mainTitle: "OUR BENEFITS",
    mainSubTitle: "WHY CHOOSE HISOL?",
    items: [
        { title: "Enhance the façade of your property." },
        { title: "Specialized team for high-altitude and hard-to-reach buildings and structures." },
        { title: "Increase your property's value." },
        { title: "Protection of your investment." },
        { title: "Tailor-made projects." },
        { title: "On-time and proper delivery guarantee." },
        { title: "International safety certifications for high-altitude and hard-to-reach work." },
        { title: "Economic flexibility." },
        { title: "Documented and informative follow-up." },
        { title: "Comprehensive coverage for buildings and structures." }
    ]
};

